<template>
    <PlanbordGridCell class="commentCell" :style="cssClasses" noPadding :title="comment.comment">
        <div class="comment">
            <span class="commentText">{{ comment.comment }}</span>
            <i v-if="canEdit" @click="showCommentDialog" class="editComment icon edit" />
        </div>
    </PlanbordGridCell>
</template>

<script lang="ts">
    import {Component, Vue, Prop} from 'vue-facing-decorator';
    import PlanbordGridCell from '@/components/Planbord/PlanbordGridCell.vue';
    import {RosterComment as RosterCommentModel} from '@cquential/api';
    import Dates from '@cquential/date-utils';
    import {PermissionsForRoster} from '@/types/types';
    import {UserPermissions} from '@/types/enums/UserPermissions';

    @Component({
        components: {
            PlanbordGridCell,
        },
        emits: ['showCommentDialog'],
    })
    export default class RosterComment extends Vue {
        @Prop({required: true}) public comment!: RosterCommentModel;
        @Prop({required: true}) public permissions!: Record<number, PermissionsForRoster>;
        @Prop({type: Date, required: true}) public firstVisibleDate!: Date;

        public get canEdit(): boolean {
            return this.comment.rosterIds!.every(
                (rosterId: number): boolean => this.permissions[rosterId] && this.permissions[rosterId][UserPermissions.EditRosterComment],
            );
        }

        public showCommentDialog(): void {
            this.$emit('showCommentDialog', this.comment);
        }

        public get cssClasses(): Partial<CSSStyleDeclaration> {
            const startDate: Date = Dates.Utils.max(this.comment.beginDate, this.firstVisibleDate);
            const start: number = Dates.Utils.diffInDays(startDate, this.firstVisibleDate) + 1;
            const span: number = Dates.Utils.diffInDays(this.comment.endDate, startDate) + 1;

            return {
                gridColumn: start + ' / span ' + span,
            };
        }
    }
</script>

<style lang="scss" scoped>
    .commentCell {
        border: 1px solid var(--cell-border-color);
        width: calc(100% + 1px);
        margin-left: -1px;
        margin-top: -1px;

        .comment {
            display: flex;
            height: 100%;
            max-width: 100%;
            align-items: center;
            justify-content: center;
            box-shadow: inset 0.25rem 0 0 0 var(--week-side-marker-color), inset -0.25rem 0 0 0 var(--week-side-marker-color);
            padding: var(--cell-padding);
            margin-inline: var(--cell-padding);
        }
    }

    .commentText {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .editComment {
        cursor: pointer;
        margin-left: 0.5rem;
        background: var(--button-teal);
    }
</style>
